import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import IndexList from '../../../lib/ui/IndexControl'
import PersonForm from '../ui/PersonForm'
import PersonModel from '../model/PersonModel'
import OrganisationModel from '../../organisation/model/OrganisationModel'
import PositionModel from '../../position/model/PositionModel'
import EducationModel from '../../education/model/EducationModel'
import LogentryModel from '../../logentry/model/LogentryModel'
import LocationModel from '../../location/model/LocationModel'
import RelationshipModel from '../../relationship/model/RelationshipModel'
import ObjectTypeMapping from '../../constants/ObjectTypeMapping'
import VcardExporter from '../exporters/VcardExporter'

export default class EditPerson {
  constructor (element, args) {
    this.onchange = () => {
      this.data = this.personForm.getValue()
      window.PRIM.initDelayedNavigation()
      window.PRIM.dataAccess.put('people', this.data.getJSON()).then((person) => {
        if (!window.PRIM.isDelayedNavigationActive())
        {
          return
        }

        if (args && !args.id && person.id) {
          window.PRIM.navigate('/people/' + person.id, true)
        }

        if (person) {
          this.data.values.id = person.id
          this.personForm.setValue(this.data)
        }        
      }).catch(window.PRIM.exceptionHandler)
    }

    if (args && args.id) {
      window.PRIM.dataAccess.resolve('people', args.id, true).then((person) => {
        this.data = person
        this.personForm.setValue(this.data)

        window.PRIM.dataAccess.get('relationships').then((relationships) => {
          let results = relationships.filter((relationship) => {
            return relationship.person_id === this.data.values.id
          })

          let promisesToResolve = 0
          this.data.relationships = results.map((relationship) => {
            let model = new RelationshipModel(relationship)
            model.person = this.data
            if (relationship.target_id) {
              promisesToResolve++
              window.PRIM.dataAccess.get('people', relationship.target_id).then((target) => {
                model.target = new PersonModel(target)
                promisesToResolve--
                if (promisesToResolve === 0) {
                  this.relationshipIndex.setItems(this.data.relationships)
                }
              }).catch((e) => {
                promisesToResolve--
                window.PRIM.exceptionHandler(e)
              })
            }

            return model
          })

          if (promisesToResolve === 0) {
            this.relationshipIndex.setItems(this.data.relationships)
          }
        }, () => {
        }).catch(window.PRIM.exceptionHandler)
        window.PRIM.dataAccess.get('positions').then((positions) => {
          let results = positions.filter((position) => {
            return position.person_id === this.data.values.id
          })

          this.data.positions = results.map((position) => {
            let model = new PositionModel(position)
            model.person = this.data
            if (position.location_id) {
              window.PRIM.dataAccess.get('locations', position.location_id).then((location) => {
                model.location = new LocationModel(location)
                if (location.organisation_id) {
                  window.PRIM.dataAccess.get('organisations', location.organisation_id).then((organisation) => {
                    model.location.organisation = new OrganisationModel(organisation)
                    this.positionIndex.setItems(this.data.positions)
                  }).catch(window.PRIM.exceptionHandler)
                } else {
                  this.positionIndex.setItems(this.data.positions)
                }
              }).catch(window.PRIM.exceptionHandler)
            }

            return model
          })

          this.positionIndex.setItems(this.data.positions)
        }, () => {
        }).catch(window.PRIM.exceptionHandler)
        window.PRIM.dataAccess.get('educations').then((educations) => {
          let results = educations.filter((education) => {
            return education.person_id === this.data.values.id
          })

          this.data.educations = results.map((education) => {
            let model = new EducationModel(education)

            if (education.location_id) {
              window.PRIM.dataAccess.get('locations', education.location_id).then((location) => {
                model.location = new LocationModel(location)
                if (location.organisation_id) {
                  window.PRIM.dataAccess.get('organisations', location.organisation_id).then((organisation) => {
                    model.location.organisation = new OrganisationModel(organisation)
                    this.educationIndex.setItems(this.data.educations)
                  }).catch(window.PRIM.exceptionHandler)
                } else {
                  this.educationIndex.setItems(this.data.educations)
                }
              }).catch(window.PRIM.exceptionHandler)
            }

            return model
          })

          this.educationIndex.setItems(this.data.educations)
        }, () => {
        }).catch(window.PRIM.exceptionHandler)
        window.PRIM.dataAccess.get('logentries').then((logentries) => {
          let results = logentries.filter((logentry) => {
            return logentry.target_id === this.data.values.id && logentry.object_type_id === ObjectTypeMapping.person
          })

          this.data.logentries = results.map((logentry) => {
            return new LogentryModel(logentry)
          })

          this.logIndex.setItems(this.data.logentries)
        }, () => {
        }).catch(window.PRIM.exceptionHandler)
      }, () => {
        if (confirm('Deze persoon bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw persoon aanmaken?')) {
          window.PRIM.navigate('/people/')
        } else {
          history.back()
        }
      }).catch(window.PRIM.exceptionHandler)
    }

    this.data = new PersonModel()

    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Persoon bewerken',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/start/')
          },
          icon: '\ue08a'
        },
        {
          onclick: this.onchange,
          icon: '\ue020',
          classes: 'indicator'
        }],
      contextMenu: [
        {
          onclick: () => {
            if (this.data.values.id) {
              window.PRIM.navigate('/relationships/new/' + this.data.values.id)
            } else {
              alert('Vul eerst gegevens voor deze persoon.')
            }
          },
          icon: '\ue083',
          label: 'Relatie'
        },
        {
          onclick: () => {
            if (this.data.values.id) {
              window.PRIM.navigate('/positions/person/' + this.data.values.id)
            } else {
              alert('Vul eerst gegevens voor deze persoon.')
            }
          },
          icon: '\ue034',
          label: 'Functie'
        },
        {
          onclick: () => {
            if (this.data.values.id) {
              window.PRIM.navigate('/logentries/person/' + this.data.values.id)
            } else {
              alert('Vul eerst gegevens voor deze persoon.')
            }
          },
          icon: '\ue032',
          label: 'Logboekregel'
        },
        {
          onclick: () => {
            if (this.data.values.id) {
              if (confirm('Weet u het zeker dat u deze persoon wilt verwijderen?')) {
                window.PRIM.dataAccess.delete('people', this.data.values.id).then(() => {
                  history.back()
                })
              }
            } else {
              alert('Vul eerst gegevens voor deze persoon.')
            }
          },
          icon: '\ue123',
          label: 'Verwijderen'
        },
        {
          onclick: () => {
            let exporter = new VcardExporter()
            let model = this.personForm.getValue()
            let vcard = exporter.export(model)
            let blob = new Blob([vcard], {type: 'text/vcard'})
            if (navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, 'export.vcf')
            } else {
              let url = URL.createObjectURL(blob)
              let tempAnchor = document.createElement('a')
              tempAnchor.href = url
              tempAnchor.download = 'export.vcf'
              tempAnchor.className = 'invisible'
              document.body.appendChild(tempAnchor)
              tempAnchor.click()
              document.body.removeChild(tempAnchor)
              URL.revokeObjectURL(url)
            }
          },
          icon: '\ue052',
          label: 'Exporteren'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let divContent = document.createElement('div')
    divContent.className = 'content'

    let primaryData = document.createElement('section')
    primaryData.className = 'primary'
    let secondaryData = document.createElement('section')
    secondaryData.className = 'secondary'

    this.personForm = new PersonForm(primaryData, {person: this.data, onchange: this.onchange})

    let fieldsetRelationships = document.createElement('fieldset')
    let legendRelationships = document.createElement('legend')
    legendRelationships.innerHTML = 'Relaties'
    fieldsetRelationships.appendChild(legendRelationships)

    let onclickRelationship = (item) => {
      window.PRIM.navigate('/relationships/' + item.values.id)
      return
    }

    this.relationshipIndex = new IndexList(fieldsetRelationships, {items: this.data.relationships, onclick: onclickRelationship})

    secondaryData.appendChild(fieldsetRelationships)

    let fieldsetPositions = document.createElement('fieldset')
    let legendPositions = document.createElement('legend')
    legendPositions.innerHTML = 'Functies'
    fieldsetPositions.appendChild(legendPositions)

    let onclickPosition = (item) => {
      window.PRIM.navigate('/positions/' + item.values.id)
      return
    }

    this.positionIndex = new IndexList(fieldsetPositions, {items: this.data.positions, onclick: onclickPosition})

    secondaryData.appendChild(fieldsetPositions)

    let fieldsetEducations = document.createElement('fieldset')
    let legendEducations = document.createElement('legend')
    legendEducations.innerHTML = 'Opleidingen'
    fieldsetEducations.appendChild(legendEducations)

    let onclickEducation = (item) => {
      window.PRIM.navigate('/educations/' + item.values.id)
      return
    }

    this.educationIndex = new IndexList(fieldsetEducations, {items: this.data.educations, onclick: onclickEducation})

    secondaryData.appendChild(fieldsetEducations)

    let fieldsetLog = document.createElement('fieldset')
    let legendLog = document.createElement('legend')
    legendLog.innerHTML = 'Logboek'
    fieldsetLog.appendChild(legendLog)

    let onclickLogentry = (item) => {
      window.PRIM.navigate('/logentries/' + item.values.id)
      return
    }

    this.logIndex = new IndexList(fieldsetLog, {items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry})

    secondaryData.appendChild(fieldsetLog)

    divContent.appendChild(primaryData)
    divContent.appendChild(secondaryData)
    div.appendChild(divContent)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/person/action/EditPerson.js